import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";

export function initSentry(): void {
  if (process.env.NODE_ENV === "production") {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_ENV,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        // TODO: check new sentry beta feature (replay)
        // new Sentry.Replay(),
      ],
      // Or however deep you want your state context to be. useful for redux integration.
      normalizeDepth: 10,
      // Releases are global per organization; prefix them with something project-specific for easy differentiation.
      release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
      // // If the entire session is not sampled, use the below sample rate to sample
      // // sessions when an error occurs.
      // replaysOnErrorSampleRate: 1.0,
      // // This sets the sample rate to be 10%. You may want this to be 100% while
      // // in development and sample at a lower rate in production
      // replaysSessionSampleRate: 1.0,
      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      tracesSampleRate: 0.1,
    });
  }
}
